import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/common/auth/hooks/useAuth';
import { GoogleSignInButton } from '@/common/auth/components/GoogleSignIn';
import { LogoMark, useModeTokens } from '@/common/components/ui';
import LandingPage from '@/routes/landing/LandingPage';

const DesktopLogin: React.FC = () => {
  const t = useModeTokens();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xs: 2, sm: 3 },
        backgroundColor: t.surfaces.canvas,
        color: t.text.primary,
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 420,
          border: `1px solid ${t.borders.medium}`,
          borderRadius: '10px',
          background: t.surfaces.panel,
          boxShadow: t.shadows.modal,
          padding: { xs: 3, sm: 4 },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <LogoMark size={30} />
        </Box>
        <Box
          component="h1"
          sx={{
            margin: '0 0 8px',
            textAlign: 'center',
            fontSize: { xs: '1.35rem', sm: '1.6rem' },
            fontWeight: 700,
          }}
        >
          Sign in to StudioVault
        </Box>
        <Box
          component="p"
          sx={{
            margin: '0 0 28px',
            textAlign: 'center',
            color: t.text.secondary,
            fontSize: '0.9rem',
            lineHeight: 1.55,
          }}
        >
          Continue with Google to access your projects, versions and boards.
        </Box>
        <GoogleSignInButton />
      </Box>
    </Box>
  );
};

const LoginPage: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const isDesktop = typeof window !== 'undefined' && !!window.electronAPI;

  useEffect(() => {
    // If user is already authenticated, redirect to projects page
    if (isAuthenticated) {
      navigate('/projects', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // Don't render anything if user is authenticated (will redirect)
  if (isAuthenticated) {
    return null;
  }

  return isDesktop ? <DesktopLogin /> : <LandingPage />;
};

export default LoginPage;
